import { all, call, put, takeLatest } from 'redux-saga/effects';
import { ItemNotification } from 'actions/actionTypes';
import * as actions from 'actions/common/itemNotification';
import { callItemNotification } from 'network/apis/common/itemNotification';

function* loadItemNotificationRequestSaga() {
    try{
        const response = yield call(callItemNotification);

        yield put(actions.loadItemNotificationSuccess(response.data))
    }
    catch(error){
        yield put(actions.loadItemNotificationFailure(error.messgae))
    }
}

export default function* root(){
    yield all([
        takeLatest(ItemNotification.LOAD_ITEM_NOTIFICATION_REQUEST, loadItemNotificationRequestSaga)
    ]);
}